import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export default function LoadingPhase() {
  return (
    <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress size={56} />
    </Box>
  );
}
